// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { FatArrow } from '../../assets/svg';
import { Target } from '../../client';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  height: 2em;
  width: 2em;
  border-radius: 50%;

  transition: all 100ms ease-in-out;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;
  -webkit-tap-highlight-color: transparent;

  ${({ $disabled }) =>
    $disabled
      ? css`
          background-color: ${theme.TMMArrowButton.disabled.backgroundColor};
          color: ${theme.TMMArrowButton.disabled.color};
          pointer-events: none;
        `
      : css`
          background-color: ${theme.TMMArrowButton.default.backgroundColor};
          color: ${theme.TMMArrowButton.default.color};

          ${!Target.__MOBILE__
            ? css`
                &:hover {
                  background-color: ${theme.TMMArrowButton.hover.backgroundColor};
                  color: ${theme.TMMArrowButton.hover.color};
                }
              `
            : css`
                &:active {
                  background-color: ${theme.TMMArrowButton.hover.backgroundColor};
                  color: ${theme.TMMArrowButton.hover.color};
                }
              `}

          &:active {
            transform: scale(0.9);
          }
        `}
`;

const ArrowWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledArrowIcon = styled(FatArrow)`
  transition: transform 300ms ease-in-out;
  width: 50%;
  height: 50%;
  ${({ $rotation }) => css`
    transform: rotate(${$rotation}deg);
  `}
`;

type ArrowButtonProps = {
  angle?: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  className?: string;
};

const ArrowButton = ({ angle = 0, disabled = false, onClick = () => {}, className }: ArrowButtonProps) => {
  return (
    <Wrapper className={className} onClick={onClick} $disabled={disabled}>
      <ArrowWrapper>
        <StyledArrowIcon $rotation={angle} />
      </ArrowWrapper>
    </Wrapper>
  );
};

export default ArrowButton;
